// extracted by mini-css-extract-plugin
export default {"leftSideNav":"LeftSideNav_leftSideNav__jeCfy"};